/**
 * Control Center access composable.
 *
 * Determines whether the current user can see and access the
 * Control Center nav section based on their role.
 */

import { getRoleId, hasControlCenterRole } from '@/composables/useAccessControl'

/**
 * Check if a given role can access the Control Center.
 *
 * @param {number|null} roleId
 * @returns {boolean}
 */
export function canAccessControlCenter(roleId) {
  if (!Number.isFinite(roleId)) return false

  return hasControlCenterRole(roleId)
}

/**
 * Synchronous getter for nav filtering / route guards.
 * Reads from localStorage (same pattern as getAdminStatusSync).
 *
 * @returns {{ hasAccess: boolean }}
 */
export function getControlCenterAccessSync() {
  const roleId = getRoleId()

  if (roleId === null) return { hasAccess: false }

  return { hasAccess: canAccessControlCenter(roleId) }
}
